export default __webpack_public_path__ + "static/MNFS-c193e93e2ee771e26ed012024e729bda.png";